// extracted by mini-css-extract-plugin
export default {"changeLoginConfirmPage":"change-login-confirm-page_changeLoginConfirmPage__ZC6mY","logo":"change-login-confirm-page_logo__II53s"};